module.exports = __webpack_public_path__ + "media/conversa/BannerConversaTolas-a720f807.png";